import { roadB2 } from "../../utils/roadB2";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapB2 = (props) => <RoadMapGeneric {...props} roadData={roadB2} />;
export default RoadMapB2;